// extracted by mini-css-extract-plugin
export var siteHead = "header-module--site-head--yNHV-";